module.exports = __webpack_public_path__ + "img/Circular economy in India.41809eff.png";